<div class="main pt-3">
  <div class="container " style="max-width: 1400px">
    <div class="row spacing-20">
      <app-user-profile-header
        [user]="user"
        class="p-0"
      />
    </div>
    <div class="row ">
      <div id="kt_user_profile_nav" class="rounded bg-gray-200 d-flex flex-stack flex-wrap mb-9 p-2" style="background-color: lightgrey" data-kt-sticky="true" data-kt-sticky-name="sticky-profile-navs" data-kt-sticky-offset="{default: false, lg: '200px'}" data-kt-sticky-width="{target: '#kt_user_profile_panel'}" data-kt-sticky-left="auto" data-kt-sticky-top="70px" data-kt-sticky-animation="false" data-kt-sticky-zindex="95">
        <ul class="nav flex-wrap border-transparent">
          <li class="nav-item my-1">
            <a class="btn btn-sm btn-color-gray-600 bg-state-body btn-active-color-gray-800 fw-bolder fw-bold fs-6 fs-lg-base nav-link px-3 px-lg-4 mx-1" [ngClass]="{ 'active': selectedTab === 'overview' }" (click)="selectedTab = 'overview'">Overview</a>
          </li>
          <li class="nav-item my-1">
            <a class="btn btn-sm btn-color-gray-600 bg-state-body btn-active-color-gray-800 fw-bolder fw-bold fs-6 fs-lg-base nav-link px-3 px-lg-4 mx-1" [ngClass]="{ 'active': selectedTab === 'horses' }" (click)="selectedTab = 'horses'">My horses</a>
          </li>
          <li class="nav-item my-1">
            <a class="btn btn-sm btn-color-gray-600 bg-state-body btn-active-color-gray-800 fw-bolder fw-bold fs-6 fs-lg-base nav-link px-3 px-lg-4 mx-1" [ngClass]="{ 'active': selectedTab === 'shows' }" (click)="selectedTab = 'shows'">Shows</a>
          </li>
          <li class="nav-item my-1">
            <a class="btn btn-sm btn-color-gray-600 bg-state-body btn-active-color-gray-800 fw-bolder fw-bold fs-6 fs-lg-base nav-link px-3 px-lg-4 mx-1" [ngClass]="{ 'active': selectedTab === 'results' }" (click)="selectedTab = 'results'">Results</a>
          </li>
          <li class="nav-item my-1">
            <a class="btn btn-sm btn-color-gray-600 bg-state-body btn-active-color-gray-800 fw-bolder fw-bold fs-6 fs-lg-base nav-link px-3 px-lg-4 mx-1" [ngClass]="{ 'active': selectedTab === 'membership' }" (click)="selectedTab = 'membership'">Membership</a>
          </li>
          <li class="nav-item my-1">
            <a class="btn btn-sm btn-color-gray-600 bg-state-body btn-active-color-gray-800 fw-bolder fw-bold fs-6 fs-lg-base nav-link px-3 px-lg-4 mx-1" [ngClass]="{ 'active': selectedTab === 'organisations' }" (click)="selectedTab = 'organisations'">Organisations</a>
          </li>
        </ul>
      </div>
    </div>
    @if (selectedTab == 'overview') {
      <app-user-profile-overview
        [user]="user"
        class="p-0"
      />
    }
    @else if (selectedTab == 'horses') {
      <app-user-profile-horses
        [user]="user"
        class="p-0"
      />
    }
    @else if (selectedTab == 'shows') {
      <!--      <app-user-shows [user]="user" class="p-0" />-->
    }
    @else if (selectedTab == 'results') {
      <!--      <app-user-results [user]="user" class="p-0" />-->
    }
    @else if (selectedTab == 'membership') {
     <app-user-profile-membership
      [user]="user"
      class="p-0"
     />
    }
    @else if (selectedTab == 'organisations') {
     <app-user-profile-organisations
      [user]="user"
      class="p-0"
     />
    }
  </div>
</div>
